const BrandVerificationSuggestionsStatus = {
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
  MERGED: 'MERGED',
  UNVERIFIABLE: 'UNVERIFIABLE',
};

export { BrandVerificationSuggestionsStatus };
